import * as TypesBind from '../types/types_bind'
import * as TypesUser from '../types/types_user'
import Vue from 'vue'

export default {
  state: {
    info: {}
  },
  mutations: {
    [TypesBind.BIND_SET_VERIFY_ACCOUNT](state, payload) {
      state.info = payload || {};
    }
  },
  actions: {
    // 验证微信账号是否已绑定并获取cookie(与user USER_GET_INFO_BY_CODE 重复)
    [TypesBind.BIND_VERIFY_ACCOUNT](ctx, { code }) {
      let params = { code }
        // 过滤多余数据
        // if (studentId && studentId != 'f71dd2a06faa555e' && studentId !== 'null' && studentId !== 'undefined') {
        //   params.studentId = studentId
        // }
        /**
         * 登陆微信
         * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E7%99%BB%E5%BD%95%E5%BE%AE%E4%BF%A1%EF%BC%88%E6%A0%B9%E6%8D%AEcode%E8%8E%B7%E5%8F%96cookie%E7%AD%89%E5%B8%90%E5%8F%B7%E4%BF%A1%E6%81%AF%EF%BC%89
         */
      return Vue.http.get('/v1/accounts/user-link', { params }).then(function(resp) {
        return Vue.checkResp(resp, {})
      }).then(data => {
        data.account = data.loginName || '';
        ctx.commit(TypesBind.BIND_SET_VERIFY_ACCOUNT, data)
        return data
      }).catch(function(err) {
        // 统一错误处理
        ctx.commit(TypesBind.BIND_SET_VERIFY_ACCOUNT, null)
        throw err
      })
    },
    /**
     * 登录以绑定微信账号
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E7%99%BB%E5%BD%95%E4%BB%A5%E7%BB%91%E5%AE%9A%E5%BE%AE%E4%BF%A1%E5%B8%90%E5%8F%B7
     */
    [TypesBind.BIND_LOGIN_ACCOUNT](ctx, { loginName, password, roleType, code }) {
      return Vue.http.put('/v1/accounts/user-link', {
        loginName,
        password,
        roleType,
        code
      }).then(function(resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        ctx.commit(TypesUser.USER_SET_INFO, data)
        return data
      }).catch(err => {
        // 统一错误处理
        ctx.commit(TypesUser.USER_SET_INFO, null)
        throw err
      })
    },
    //仅登录不绑定微信
    // [TypesBind.BIND_ONLY_LOGIN_ACCOUNT](ctx, { loginName, password, roleType, code }) {
    //   return Vue.http.post('/v1/accounts/sessions', {
    //     loginName, password, roleType, code
    //   }).then(function (resp) {
    //     return Vue.checkResp(resp);
    //   }).then(data => {
    //     ctx.commit(TypesUser.USER_SET_INFO, data)
    //     return data;
    //   }).catch(err => {
    //     //统一错误处理
    //     ctx.commit(TypesUser.USER_SET_INFO, data)
    //     throw err;
    //   });
    // },
    /**
     * 由studentID绑定学生
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E6%A0%B9%E6%8D%AE%E5%AD%A6%E7%94%9Fid%E7%BB%91%E5%AE%9A%E5%AD%A6%E7%94%9F
     */
    [TypesBind.BIND_BY_STUDENT_ID](ctx, params) {
      return Vue.http.post('/v1/accounts/native-users/bind-students', params).then(function(resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      }).catch(err => {
        throw err
      })
    },
    /**
     * 匹配用户信息，根据 用户名/手机/邮箱 获取对应用户（用户名/手机号/邮箱 查重)
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=14353072#id-%E7%94%A8%E6%88%B7API-%E5%8C%B9%E9%85%8D%E7%94%A8%E6%88%B7%E4%BF%A1%E6%81%AF%EF%BC%8C%E6%A0%B9%E6%8D%AE%E7%94%A8%E6%88%B7%E5%90%8D/%E6%89%8B%E6%9C%BA/%E9%82%AE%E7%AE%B1%E8%8E%B7%E5%8F%96%E5%AF%B9%E5%BA%94%E7%94%A8%E6%88%B7%EF%BC%88%E7%94%A8%E6%88%B7%E5%90%8D/%E6%89%8B%E6%9C%BA%E5%8F%B7/%E9%82%AE%E7%AE%B1%E6%9F%A5%E9%87%8D)
     */
    [TypesBind.BIND_CHECK_ACCOUNT](ctx, { account, roleType }) {
      return Vue.http.get('/v1/be-proxy/v2/users/matched-users', {
        params: { account, roleType }
      }).then(function(resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      })
    },
    /**
     * 发送注册验证码
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=16908963#id-%E8%87%AA%E4%B8%BB%E6%B3%A8%E5%86%8C%E7%94%A8%E6%88%B7%E6%B3%A8%E5%86%8C%E6%BF%80%E6%B4%BBAPI-%E5%8F%91%E9%80%81%E6%89%8B%E6%9C%BA%E6%B3%A8%E5%86%8C%E7%94%A8%E6%88%B7%E7%9A%84%E7%9F%AD%E4%BF%A1%E9%AA%8C%E8%AF%81%E7%A0%81%EF%BC%9A
     */
    [TypesBind.BIND_SEND_REGISTER_MSG](ctx, postData) {
      return Vue.http.post('/v1/be-proxy/v2/native-users/verification-msg-with-captcha', postData)
        .then(resp => Vue.checkResp(resp))
        .then(data => data)
    },
    /**
     * 注册并激活自主注册账号
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E6%B3%A8%E5%86%8C%E5%B9%B6%E6%BF%80%E6%B4%BB%E8%87%AA%E4%B8%BB%E6%B3%A8%E5%86%8C%E8%B4%A6%E5%8F%B7%EF%BC%88%E9%82%AE%E7%AE%B1/%E6%89%8B%E6%9C%BA%EF%BC%89
     * deviceType用户来源 1 ANDROID   2 IOS  3 WEB  4 WECHAT
     */
    [TypesBind.BIND_REGISTER_ACCOUNT](ctx, { phoneNumber, password, verificationCode, code, roleType }) {
      let verificationMsgToken = JSON.stringify({
        phoneNumber,
        password,
        verificationCode,
        roleType
      })
      return Vue.http.post('/v1/accounts/users-without-student', {
        code,
        roleType,
        verificationType: 2,
        deviceType: 4,
        verificationMsgToken
      }).then(function(resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        ctx.commit(TypesUser.USER_SET_INFO, data)
        return data
      }).catch(err => {
        // 统一错误处理
        ctx.commit(TypesUser.USER_SET_INFO, null)
        throw err
      })
    },
    /**
     * 注册(不绑定微信), 参数里没有code；
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E6%B3%A8%E5%86%8C(%E4%B8%8D%E7%BB%91%E5%AE%9A%E5%BE%AE%E4%BF%A1)
     * deviceType用户来源 1 ANDROID   2 IOS  3 WEB  4 WECHAT
     */
    [TypesBind.BIND_BY_BEROUTE](ctx, { phoneNumber, password, verificationCode, roleType }) {
      let verificationMsgToken = JSON.stringify({
        roleType,
        phoneNumber,
        password,
        verificationCode
      })
      return Vue.http.post('/v1/accounts/users-without-wechat', {
        roleType,
        verificationType: 2,
        deviceType: 4,
        verificationMsgToken
      }).then(function(resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        ctx.commit(TypesUser.USER_SET_INFO, data)
        return data
      }).catch(err => {
        // 统一错误处理
        ctx.commit(TypesUser.USER_SET_INFO, null)
        throw err
      })
    },
    /**
     * 解绑微信账号
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=27986959#hfs-wechat%E5%B8%90%E5%8F%B7%E4%BD%93%E7%B3%BBAPI-%E7%99%BB%E5%BD%95%E4%BB%A5%E7%BB%91%E5%AE%9A%E5%BE%AE%E4%BF%A1%E5%B8%90%E5%8F%B7
     */
    [TypesBind.BIND_DELETE_ACCOUNT](ctx, { code }) {
      return Vue.http.delete('/v1/accounts/user-link', { params: { code } }).then(function(resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        ctx.commit(TypesBind.BIND_SET_VERIFY_ACCOUNT, data)
        return data
      }).catch(err => {
        // 统一错误处理
        // ctx.commit(TypesUser.USER_SET_INFO, null);
        throw err
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/ReportApp/store/modules/modules_bind.js